
const rhymes = (state=[], action) => {
    switch (action.type) {
        
        // case UPDATE_LINE:
        //   return {
        //     ...state,
        //     [action.lineId]: getUpdatedLine(state[action.lineId], action.values)
        //   };

        default:
            return state;
    }
}

  
export default rhymes;



// WEBPACK FOOTER //
// ./src/reducers/rhymes.js